'use client'

import React, { useState } from "react";
import styles from "./ContactSplitSection.module.scss";
import { useAOS } from "@/src/lib/hooks/useAOS";


interface ContactInfo {
    locationLabel: string;
    phoneLabel: string;
    whatsappPhoneLabel: string;
    whatsappPhone: string;
    emailLabel: string;
    hoursLabel: string;
    location: string;
    phone: string;
    email: string;
    hours: string;
}

interface ContactSplitSectionProps {
    backgroundImage: string;
    bottomBackgroundImage: string;
    title?: string;
    description?: string;
    contactInfo: ContactInfo;
    onSendMessage?: (data: { name: string; subject: string; message: string }) => void;
}

const ContactSplitSection: React.FC<ContactSplitSectionProps> = ({
    backgroundImage,
    bottomBackgroundImage,
    title = "Contact Us",
    description = "We'd love to hear from you. Reach out with any questions or messages.",
    contactInfo,
    onSendMessage,
}) => {
    useAOS();
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const form = e.currentTarget;
        const data = {
            name: (form.elements.namedItem("name") as HTMLInputElement).value,
            email: (form.elements.namedItem("email") as HTMLInputElement).value,
            phone: (form.elements.namedItem("phone") as HTMLInputElement).value,
            subject: (form.elements.namedItem("subject") as HTMLInputElement).value,
            message: (form.elements.namedItem("message") as HTMLTextAreaElement).value,
        };
        try {
            const res = await fetch('/api/contact', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            });

            const result = await res.json();
            if (res.ok) {
                setShowSuccessMessage(true);
                setTimeout(() => {
                    setShowSuccessMessage(false);
                }, 6000);
                form.reset();
            } else {
                alert(`Error: ${result.error}`);
            }
        } catch (err) {
            console.error(err);
            alert('An unexpected error occurred.');
        }
    };



    return (
        <section
            className={styles.contactSection}
            style={{ backgroundImage: `url(${backgroundImage})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }}
        >

            {
                showSuccessMessage && (
                    <div className={styles.popupSuccess}>
                        Votre message a bien été envoyé. Nous vous contacterons dans les meilleurs délais.
                    </div>
                )
            }
            <div className={styles.maskedBackground} data-aos="fade-down" data-aos-delay="200" data-aos-easing="ease-in-out">
                <div className={styles.topHalf}>
                    <h1>{title}</h1>
                    <p>{description}</p>
                </div>

                <div
                    className={styles.bottomHalf}
                    style={{ backgroundImage: `url(${bottomBackgroundImage})` }}
                >
                    <div className={styles.bottomOverlay}>
                        <div className={styles.redBox} data-aos="fade-right" data-aos-delay="200" data-aos-easing="ease-in-out">
                            <div className={styles.contactInfo}>
                                <p><strong>{contactInfo.locationLabel}</strong> {contactInfo.location}</p>
                                <p><strong>{contactInfo.phoneLabel}</strong> {contactInfo.phone}</p>
                                <p><strong>{contactInfo.whatsappPhoneLabel}</strong> {contactInfo.whatsappPhone}</p>
                                <p><strong>{contactInfo.emailLabel}</strong> {contactInfo.email}</p>
                                <p><strong>{contactInfo.hoursLabel}</strong> {contactInfo.hours}</p>
                            </div>
                        </div>

                        <form className={styles.contactForm} onSubmit={handleSubmit} data-aos="fade-left" data-aos-delay="200" data-aos-easing="ease-in-out">
                            <input type="text" name="name" placeholder="Votre prénom" required />
                            <input type="email" name="email" placeholder="Votre email" required />
                            <input type="text" name="phone" placeholder="Votre téléphone" />
                            <input type="text" name="subject" placeholder="Sujet" required />
                            <textarea name="message" placeholder="Votre message" rows={4} required />
                            <button type="submit">Envoyer</button>
                        </form>                    </div>
                </div>
            </div>
        </section>
    );
};

export default ContactSplitSection;






